export function sanitize(str: string) {
  return str.replace(/[-_]/g, " ");
}

export function sanitizeItemStatusLabel(status: string): string {
  const statusMap: Record<string, string> = {
    "on_site": "On Site",
    "in_stock": "In Stock",
    "in_delivery": "In Delivery",
    "in_retrieval": "In Retrieval",
    "in_maintenance": "In Maintenance",
    "missing": "Missing",
    "incomplete": "Incomplete",
    "in_stock_main": "In Stock (Main)",
    "in_transit_to_sub": "In Transit (to Sub)",
    "inbound_sub": "Inbound (Sub)",
    "in_stock_sub": "In Stock (Sub)",
    "issued_to_field": "Issued (to Field)",
    "delivered": "Delivered",
    "storm_stock": "Storm Stock",
  };

  return statusMap[status.toLowerCase()] || status;
}

export function isValidEmail(email: string): boolean {
  return /^\S+@\S+\.\S+$/.test(email);
}
